import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API, PORTAL_TOKEN_KEY } from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Loader2, XCircle } from "lucide-react";

export default function PortalLogin() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const token = params.get("token");

  useEffect(() => {
    if (!token) { setError("This portal link is invalid."); return; }
    (async () => {
      try {
        const { data } = await axios.post(`${API}/portal/login`, { token });
        localStorage.setItem(PORTAL_TOKEN_KEY, data.token);
        navigate("/portal", { replace: true });
      } catch (e) {
        setError(e.response?.data?.detail || "This portal link is invalid or has expired.");
      }
    })();
  }, [token, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="absolute inset-0 bc-grid-bg opacity-30" />
      <div className="relative w-full max-w-md rounded-2xl border border-border bg-card p-8 text-center shadow-xl">
        <div className="mb-6 flex justify-center"><Link to="/"><Logo /></Link></div>
        {error ? (
          <>
            <div className="mb-4 flex justify-center"><XCircle className="h-10 w-10 text-critical" /></div>
            <h1 className="font-heading text-xl font-bold">Access link problem</h1>
            <p className="mt-2 text-sm text-muted-foreground" data-testid="portal-login-error">{error}</p>
            <p className="mt-4 text-xs text-muted-foreground">Please contact your account manager for a fresh secure link.</p>
          </>
        ) : (
          <>
            <div className="mb-4 flex justify-center"><Loader2 className="h-10 w-10 animate-spin text-primary" /></div>
            <h1 className="font-heading text-xl font-bold">Signing you in…</h1>
            <p className="mt-2 text-sm text-muted-foreground">Verifying your secure portal link.</p>
          </>
        )}
      </div>
    </div>
  );
}
